function getPanelContentDiv(panelId) {
  if (panelId === null) {
    return null;
  }
  return document.querySelector(`div#panel-${panelId} .panel-content`);
}

export function calculatePanelHeight(panelId) {
  const panelContentDiv = getPanelContentDiv(panelId);
  return panelContentDiv ? panelContentDiv.clientHeight : null;
}
